import moment from 'moment';

export default class {

    $get () {
        return moment;
    }

}



// WEBPACK FOOTER //
// ./src/app/providers/moment/index.js